import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modules" }

import PedallingAnalyzerModule from '@/components/controls/modules/PedallingAnalyzerModule.vue'
import HeartrateModule from '@/components/controls/modules/HeartrateModule.vue'
import SaddleModule from '@/components/controls/modules/SaddleModule.vue'
import HandlebarModule from '@/components/controls/modules/HandlebarModule.vue'
import ResistanceModule from '@/components/controls/modules/ResistanceModule.vue'
import XYToolModule from '@/components/controls/modules/XYToolModule.vue'
import EmptyModule from '@/components/controls/modules/EmptyModule.vue'
import MotionAnalyzerModule from '@/components/controls/modules/MotionAnalyzerModule.vue'
import { useMqttStore } from '@/store/mqttStore'
import { usePreferenceStore } from '@/store/preferenceStore'
import { storeToRefs } from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'BikeModules',
  setup(__props) {

const mqttStore = useMqttStore()
const preferenceStore = usePreferenceStore()

const { connected } = storeToRefs(mqttStore)
const {
  hasFitbike,
  hasPositioningMotors,
  hasXYTool,
  has3DMotionAnalyzer,
  has3DPedallingAnalyzer,
  hasHeartRateMonitor,
} = storeToRefs(preferenceStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(connected))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createVNode(SaddleModule, { class: "modules__item" }, null, 512), [
            [_vShow, _unref(hasFitbike) && _unref(hasPositioningMotors)]
          ]),
          _withDirectives(_createVNode(HandlebarModule, { class: "modules__item" }, null, 512), [
            [_vShow, _unref(hasFitbike) && _unref(hasPositioningMotors)]
          ]),
          (_unref(hasXYTool))
            ? (_openBlock(), _createBlock(XYToolModule, {
                key: 0,
                class: "modules__item"
              }))
            : _createCommentVNode("", true),
          _createVNode(ResistanceModule, { class: "modules__item" }),
          (_unref(hasHeartRateMonitor))
            ? (_openBlock(), _createBlock(HeartrateModule, {
                key: 1,
                class: "modules__item"
              }))
            : _createCommentVNode("", true),
          (_unref(has3DPedallingAnalyzer))
            ? (_openBlock(), _createBlock(PedallingAnalyzerModule, {
                key: 2,
                class: "modules__item"
              }))
            : _createCommentVNode("", true),
          (_unref(has3DMotionAnalyzer))
            ? (_openBlock(), _createBlock(MotionAnalyzerModule, {
                key: 3,
                class: "modules__item"
              }))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(EmptyModule, {
          key: 1,
          class: "modules__item"
        }))
  ]))
}
}

})